// Shader del pla central del ThumbnailObject: textura + opacitat + blur (bokeh).
// Versió simplificada de THUMBNAIL_FRAGMENT (sense màscara/overlay/darken): només
// mostra la imatge amb un blur de 9 mostres controlat per ProductsScene segons profunditat.

export const THUMBNAIL_OBJECT_VERTEX = `
    varying vec2 vUv;
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

export const THUMBNAIL_OBJECT_FRAGMENT = `
    precision mediump float;

    uniform sampler2D map;
    uniform float opacity;
    uniform float blur;
    uniform vec2 cover; // factor UV per cobrir el pla conservant aspect (background-size: cover)

    varying vec2 vUv;

    vec4 sampleBlurred(sampler2D tex, vec2 uv, float r) {
        if (r < 0.0001) return texture2D(tex, uv);
        vec4 col = vec4(0.0);
        col += texture2D(tex, uv + vec2( r,            0.0));
        col += texture2D(tex, uv + vec2(-r,            0.0));
        col += texture2D(tex, uv + vec2( 0.0,          r));
        col += texture2D(tex, uv + vec2( 0.0,         -r));
        col += texture2D(tex, uv + vec2( r * 0.707,    r * 0.707));
        col += texture2D(tex, uv + vec2(-r * 0.707,    r * 0.707));
        col += texture2D(tex, uv + vec2( r * 0.707,   -r * 0.707));
        col += texture2D(tex, uv + vec2(-r * 0.707,   -r * 0.707));
        col += texture2D(tex, uv);
        return col / 9.0;
    }

    void main() {
        vec2 uv = (vUv - 0.5) * cover + 0.5;
        vec4 c = sampleBlurred(map, uv, blur);
        float a = c.a * opacity;
        if (a < 0.01) discard;
        gl_FragColor = vec4(c.rgb, a);
    }
`;
